import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { v4 as uuid } from "uuid";
import { object, string } from "yup";
import DropdownCmp2 from "../../../components/dropdown/DropdownCmp2";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import { GetApplicationsResponse } from "../../../models/menu.model";
import {
  AddPermissionGroupRequest,
  AddPermissionResponse,
  GetPermissionGroupsWithSubPermissionsResponse,
} from "../../../models/permission.model";
import { GetApplications } from "../../../services/menu.service";
import {
  AddPermissionGroup,
  EditPermissionGroup,
} from "../../../services/permission.service";
const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },
  maxHeight: "70vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "3vh",
  // direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

const editReportValidationSchema = object().shape({
  title: string()
    .ensure()
    .required("لطفا نام فارسی را وارد نمایید")
    .max(150, "نام فارسی نباید بیش از ۱۵۰ کاراکتر باشد"),
  name: string()
    .ensure()
    .required("لطفا نام انگلیسی را وارد نمایید")
    .max(150, "نام انگلیسی نباید بیش از ۱۵۰ کاراکتر باشد"),
});

interface Props {
  openAddPermissionModal: boolean;
  setOpenAddPermissionModal: (openAddPermissionModal: boolean) => void;
  setUpdateReports: (state: string) => void;
  addOrEdit: "Add" | "Edit";
  choosedPermission: GetPermissionGroupsWithSubPermissionsResponse;
}

const AddEditPermissionModal = ({
  openAddPermissionModal,
  setOpenAddPermissionModal,
  setUpdateReports,
  addOrEdit,
  choosedPermission,
}: Props) => {
  const [applicationOption, setApplicationOption] = useState<
    GetApplicationsResponse[]
  >([]);
  const [applicationValue, setApplicationValue] = useState<string>();
  const initialValues: AddPermissionGroupRequest = {
    title: addOrEdit === "Add" ? "" : choosedPermission?.title,
    name: addOrEdit === "Add" ? "" : choosedPermission?.name,
    applicationId: "",
  };
  const { mutate: AddPermissionGroupMutate } = useMutation(AddPermissionGroup, {
    onSuccess: (data: AddPermissionResponse) => {
      if (data) {
        setOpenAddPermissionModal(false);
        setUpdateReports(uuid());
      }
    },
    onError: () => {},
  });
  const { mutate: EditPermissionGroupMutate } = useMutation(
    EditPermissionGroup,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          setOpenAddPermissionModal(false);
          setUpdateReports(uuid());
        }
      },
      onError: () => {},
    }
  );
  const { mutate: GetApplicationsMutate } = useMutation(GetApplications, {
    onSuccess: (data: GetApplicationsResponse[]) => {
      if (data) {
        setApplicationOption(data);
      }
    },
    onError: () => {},
  });

  const handleSubmitReport = (values: AddPermissionGroupRequest) => {
    if (addOrEdit === "Add") {
      AddPermissionGroupMutate({
        name: values.name,
        title: values.title,
        applicationId: applicationValue!,
      });
    } else {
      EditPermissionGroupMutate({
        name: values.name,
        title: values.title,
        applicationId: applicationValue!,
        id: choosedPermission.id,
      });
    }
  };

  useEffect(() => {
    GetApplicationsMutate();
  }, []);

  useEffect(() => {
    if (addOrEdit === "Edit") {
      setApplicationValue(choosedPermission?.applicationId);
    }
  }, [addOrEdit]);

  const handleSelectedDrop = (e: any) => {
    setApplicationValue(e.target.value);
  };
  return (
    <>
      <div>
        <Modal
          open={openAddPermissionModal}
          onClose={() => setOpenAddPermissionModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={deactiveUserStyle}>
            <Typography
              component={"p"}
              display={"block"}
              textAlign={"center"}
              fontWeight={"bold"}
              //   marginY={"3rem"}
              fontSize={"14px"}
              color={"#1D4A87"}
            >
              {addOrEdit === "Add" ? (
                <span>افزودن گروه دسترسی</span>
              ) : (
                <span>ویرایش گروه دسترسی</span>
              )}
            </Typography>
            <>
              <Formik
                initialValues={initialValues}
                onSubmit={handleSubmitReport}
                validateOnMount={true}
                validationSchema={editReportValidationSchema}
              >
                {({
                  handleSubmit,
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Grid
                      container
                      gap={"2rem"}
                      marginTop={"15px"}
                      maxWidth={"400px"}
                    >
                      <Grid item xs={12}>
                        <MaterialTextFieldComponent
                          placeHolder={"نام فارسی"}
                          label={"نام فارسی"}
                          required={true}
                          name={"title"}
                          id={"title"}
                          value={values.title}
                          helperText={touched.title ? errors.title : ""}
                          error={touched.title && Boolean(errors.title)}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <MaterialTextFieldComponent
                          placeHolder={"نام انگلیسی"}
                          label={"نام انگلیسی"}
                          required={true}
                          name={"name"}
                          id={"name"}
                          value={values.name}
                          helperText={touched.name ? errors.name : ""}
                          error={touched.name && Boolean(errors.name)}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          onKeyDown={(e) => {
                            if (
                              /^[آ-ی ء چ]+$/.test(e.key) &&
                              e.code !== "Space"
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} className="dropdownCmp2-container">
                        <DropdownCmp2
                          style={
                            {
                              // maxWidth:
                              //   orederStateValue === "DeliveredToCustomer"
                              //     ? "500px"
                              //     : "300px",
                            }
                          }
                          onChange={handleSelectedDrop}
                          value={applicationValue}
                          label={"سامانه*"}
                          options={applicationOption}
                          name="appType"
                          id="appType"
                          darkTheme={true}
                          // defaultValue={dafaultDropdownValue}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Grid
                          container
                          justifyContent={"center"}
                          alignItems={"center"}
                          gap={1}
                          marginBottom={"8px"}
                        >
                          <Grid item xs={5} width={"100%"}>
                            <Button
                              fullWidth
                              type="submit"
                              variant="contained"
                              sx={{ borderRadius: "5px !important" }}
                              disabled={
                                !values.title ||
                                !values.name ||
                                !applicationValue ||
                                (values.title === choosedPermission?.title &&
                                  values.name === choosedPermission?.name &&
                                  applicationValue ===
                                    choosedPermission.applicationId)
                              }
                              className={
                                !values.title ||
                                !values.name ||
                                !applicationValue ||
                                (values.title === choosedPermission?.title &&
                                  values.name === choosedPermission?.name &&
                                  applicationValue ===
                                    choosedPermission?.applicationId)
                                  ? "btnForm disabledBtn"
                                  : "btnForm SuccessDefault"
                              }
                            >
                              ثبت
                            </Button>
                          </Grid>
                          <Grid item xs={5} width={"100%"}>
                            <Button
                              fullWidth
                              variant="contained"
                              style={{
                                fontSize: "1rem",
                                color: "#fff",
                                height: "40px",
                                background: "#607D8B",
                              }}
                              sx={{ borderRadius: "5px !important" }}
                              onClick={() => setOpenAddPermissionModal(false)}
                            >
                              انصراف
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                )}
              </Formik>
            </>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default AddEditPermissionModal;
